import { TranslateHelper } from '../../helpers/injector.helper';
import { ValueAndType } from '../basic/formulaEditor.model';
import { OperationType } from '../enums/operationtype.enum';
import { ValueType } from '../enums/valuetype.enum';
import { FormulaNodeCalculator } from './formula.node.calculator';
import { AFormula, FormulaGroups } from './iformula';

export abstract class AReplace extends AFormula {
    MinVariableCount(): number {
        return 3;
    }
    MaxVariableCount(): number {
        return 3;
    }
    CanCalcNulls(): boolean {
        return true;
    }
    Group(): string {
        return FormulaGroups.Functions;
    }
    OperationType(): OperationType {
        return OperationType.Function;
    }
    OperationValue(): string {
        return this.Name() + '(' + TranslateHelper.TranslatorInstance.instant('@@Text') +
            '; ' + TranslateHelper.TranslatorInstance.instant('@@SearchText') +
            '; ' + TranslateHelper.TranslatorInstance.instant('@@ReplaceText') + ')';
    }

    abstract ReplaceInternal(text: string, searchString: string, replaceString: string): string;

    Calc(fnc: FormulaNodeCalculator, maxType: ValueType, args?: ValueAndType[]): ValueAndType {
        const retVal = new ValueAndType();
        retVal.Type = ValueType.String;
        retVal.Value = '';
        if (args && args.length >= 3) {
            if (typeof args[0].Value !== 'undefined' && args[0].Value != null) {
                const text = String(args[0].Value);
                if (text) {
                    retVal.Value = text;
                    if (typeof args[1].Value !== 'undefined' && args[1].Value != null) {
                        const searchString = String(args[1].Value);
                        if (searchString) {
                            let replaceString = '';
                            if (typeof args[2].Value !== 'undefined' && args[2].Value != null) {
                                replaceString = String(args[2].Value);
                            }
                            retVal.Value = this.ReplaceInternal(text, searchString, replaceString);
                        }
                    }
                }
            }
        }
        return retVal;
    }
}

export class Replace extends AReplace {
    static StaticID: string = 'f818af6e-6720-4bb8-916b-443654d61d25';

    ID(): string {
        return Replace.StaticID;
    }

    Name(): string {
        return 'Replace';
    }

    Description(): string {
        return TranslateHelper.TranslatorInstance.instant('@@Ersetzen einer bestimmten Zeichenfolge');
    }

    OrderID(): number {
        return 17;
    }

    ReplaceInternal(text: string, searchString: string, replaceString: string): string {
        return text.replace(searchString, replaceString);
    }
}

export class RegexReplace extends AReplace {
    static StaticID: string = 'bb5cc8ca-7f3f-419c-b73b-9ed67c4068e6';

    ID(): string {
        return RegexReplace.StaticID;
    }

    Name(): string {
        return 'RegexReplace';
    }

    Description(): string {
        return TranslateHelper.TranslatorInstance.instant('@@Ersetzen einer bestimmten Zeichenfolge mit Regular Expressions');
    }

    OrderID(): number {
        return 18;
    }

    ReplaceInternal(text: string, searchString: string, replaceString: string): string {
        return text.replace(new RegExp(searchString), replaceString);
    }
}